import React from 'react';
import { steps } from '../data/landing';
export function HowItWorks() {
  return <section className="w-full bg-cream py-16 lg:py-24" data-id="element-101" data-mp="7slq0yyp41rl">
      <div className="mx-auto max-w-5xl px-6" data-id="element-102" data-mp="7u6j0k5d3cnc">
        <h2 className="font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-103" data-mp="3pz01mr9hrzmt">
          Cómo funciona, paso a paso
        </h2>

        <ol className="mt-12 space-y-0" data-id="element-104" data-mp="3u0lj6pwz123c">
          {steps.map((step, index) => <li key={step.name} className="relative flex gap-6 pb-12 last:pb-0" data-id="element-105" data-mp="lll3ywitxnx1" data-mpi={index}>
              {index < steps.length - 1 && <span className="absolute left-7 top-14 bottom-0 w-px bg-teal/25" aria-hidden="true" data-id="element-106" data-mp="qlh76tjpdbbj" />}
              <span className="relative flex h-14 w-14 flex-none items-center justify-center rounded-full bg-teal font-serif text-2xl font-semibold text-white" data-id="element-107" data-mp="gs8rfkrfd7kn">
                {index + 1}
              </span>
              <div className="pt-2" data-id="element-108" data-mp="19bfdb43xwucj">
                <h3 className="font-serif text-2xl font-semibold text-ink sm:text-3xl" data-id="element-109" data-mp="2rlny9e094oye">
                  {step.name}
                </h3>
                <p className="mt-2 max-w-readable font-sans text-xl leading-relaxed text-inkSoft" data-id="element-110" data-mp="2mnmgqxih4xp1">
                  {step.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}